module.exports = __webpack_public_path__ + "static/media/banner.32e6ab49.png";